// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".condition-block{padding-top:10px;clear:both}#condition-good:before{background-image:url(/img/thumb-up-svgrepo-com.svg);height:35px;width:35px;background-size:35px;margin-top:20px}#condition-good:before,#condition-ideal:before{content:\"\"!important;background-repeat:no-repeat}#condition-ideal:before{background-image:url(/img/best-outline-red-svgrepo-com.svg);height:55px;width:55px;background-size:55px;margin-top:14px}", ""]);
// Exports
module.exports = exports;
